module.exports = __webpack_public_path__ + "static/media/aus-flag.af35734f.svg";